import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const PenetrationTesting: React.FC = () => {
  const sections = [
    {
      title: 'Expert Penetration Testing Services',
      content: 'Our penetration testing services simulate real-world cyberattacks to identify vulnerabilities and security weaknesses in your systems, networks, and applications. Our certified ethical hackers use advanced techniques to test your defenses and provide actionable recommendations for improvement.',
      benefits: [
        'Network and infrastructure penetration testing',
        'Web and mobile application security testing',
        'Wireless network security assessment',
        'Social engineering and phishing simulations',
        'Physical security testing and assessments'
      ]
    },
    {
      title: 'Testing Methodologies',
      content: 'Our penetration testing follows industry-standard methodologies including OWASP, NIST, and PTES frameworks to ensure comprehensive and reliable results.',
      benefits: [
        'Black box, white box, and gray box testing',
        'Automated and manual testing techniques',
        'Risk-based testing prioritization',
        'Compliance-focused testing (PCI DSS, HIPAA)',
        'Post-exploitation analysis and impact assessment'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Penetration Testing"
      subtitle="Professional penetration testing services to identify vulnerabilities and strengthen your security defenses through simulated cyberattacks."
      sections={sections}
    />
  );
};

export default PenetrationTesting;

